import {ClientFeatures, Plans, moduleFeatures, BusinessModuleType} from '@torim-app/types';

export const checkFeatureIsAvailable = (
  feature: ClientFeatures,
  plan: Plans,
  businessModule: BusinessModuleType = BusinessModuleType.BEAUTY,
  enabledFeatures: Array<ClientFeatures> = []
): boolean => {
  // First check if feature is enabled for this specific business
  if (enabledFeatures.includes(feature)) {
    return true;
  }

  // Then check if it's a default feature for this module
  if (moduleFeatures[businessModule].defaultFeatures.includes(feature)) {
    return true;
  }

  // If it's an optional feature, check the plan
  if (moduleFeatures[businessModule].optionalFeatures.includes(feature)) {
    // Free plan only gets default features
    if (plan === Plans.FREE) {
      return false;
    }

    // Premium plan gets all features
    if (plan === Plans.PREMIUM) {
      return true;
    }
  }

  return false;
};
